/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Col, Row, Typography } from 'antd';

import { TextField } from '@molecules';
import MediaField from '@organisms/MediaField';
import { Button } from '@atoms';

import Form from '../Form';

import { SCROLL_NEWS_ITEM_FIELDS } from './constant';
import { IMAGE_SIZE } from '@api/media/constants';

const HeroSlidesForm = ({ onSubmit, initialValues: initData, buttons, className, isUltimateDesign }) => {
  const scrollNewsItemFields = SCROLL_NEWS_ITEM_FIELDS;
  if (isUltimateDesign) {
    scrollNewsItemFields.SLIDE_STRAPLINE.rules = [];
    scrollNewsItemFields.SLIDE_SUBTITLE = {
      ...scrollNewsItemFields.SLIDE_SUBTITLE,
      label: 'Description:',
    };
    scrollNewsItemFields.SLIDE_IMAGE.size = IMAGE_SIZE['300x191'];
  }
  const [form] = Form.useForm(scrollNewsItemFields);
  const initialValues = React.useMemo(() => form.deserialize(initData), [form, initData]);

  const handleFinish = React.useCallback(
    (value) => {
      onSubmit(value, initData);
      form.resetFields();
    },
    [form, onSubmit, initData],
  );

  return (
    <Form
      onSerializedFinish={handleFinish}
      initialValues={initialValues}
      className={className}
      layout="vertical"
      labelAlign="left"
      colon={false}
      form={form}
    >
      {buttons && <Typography.Text level={3}>Edit Slide</Typography.Text>}
      <Row>
        <Col flex="1">
          <Row>
            <Col flex="1">
              <MediaField {...scrollNewsItemFields.SLIDE_IMAGE} />
              <TextField {...scrollNewsItemFields.SLIDE_TITLE} />
              <TextField {...scrollNewsItemFields.SLIDE_SUBTITLE} />
              {!isUltimateDesign && <TextField {...scrollNewsItemFields.SLIDE_STRAPLINE} />}
              <TextField {...scrollNewsItemFields.SLIDE_READ_MORE_LINK} />
              <TextField {...scrollNewsItemFields.SLIDE_READ_MORE_TEXT} />
              <TextField {...scrollNewsItemFields.SLIDE_DATE} />
            </Col>
          </Row>
          <Row>
            <Col flex="1" gutter={10}>
              {buttons ? (
                buttons({ onSubmit: form.submit })
              ) : (
                <Button type="customBlue" style={{ minWidth: 200 }} onClick={form.submit}>
                  ADD SLIDE
                </Button>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};

export default HeroSlidesForm;
